import { create } from "zustand";
import { persist, devtools } from "zustand/middleware";
import { createPreferenceActions } from "./userPreferences/createPreferenceActions";
import { createCacheActions } from "./userPreferences/createCacheActions";
import { initialState, persistConfig } from "./userPreferences/storeConfig";

/**
 * Centralized User Preferences Store
 * 
 * This store manages all user preferences with:
 * - Automatic caching to avoid redundant API calls
 * - Optimistic updates for better UX
 * - Persistence to sessionStorage
 * - Dynamic preference keys
 * - Batch operations for performance
 */

const useUserPreferencesStore = create(
  devtools(
    persist(
      (set, get) => ({
        // Initial State
        ...initialState,

        // Preference Actions
        ...createPreferenceActions(set, get),

        // Cache Actions
        ...createCacheActions(set, get),
      }),
      persistConfig
    )
  )
);

export default useUserPreferencesStore;
